module.exports = __webpack_public_path__ + "static/img/no-order.fb7af991.png";